import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annoucments',
  templateUrl: './annoucments.component.html',
  styleUrls: ['./annoucments.component.css']
})
export class AnnoucmentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/annoucments/annoucments.component.ts